import Loader from "components/Loader/Loader";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getProjectsList,
  selectState,
  setEditNotePopoverOpen,
  updateProject
} from "../main.slice";
import DeleteProjectModal from "./DeleteProjectModal";
import ProjectHeaderRow from "./ProjectHeaderRow";
import ProjectRow from "./ProjectRow";
import Popover from "components/Popover/Popover";
import EditNotePopover from "Dashboard/components/EditNotePopover";
import { projectService } from "Dashboard/scenes/Projects/services/project.service";
import { useEmployeeOptions } from "Dashboard/scenes/HumanResources/hooks/EmployeeOptions";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { PROJECT_MODULE_NAME } from "Dashboard/scenes/Projects/domain/ProjectModule";

const TopSection = () => {
  const {
    loading,
    projects,
    permission,
    editNotePopoverOpen
  } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);
  const employeeOptions = useEmployeeOptions();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (permission && permission !== "none") {
      dispatch(getProjectsList({ permission }));
    }
  }, [dispatch, permission]);

  return (
    <section className="loading-container">
      {loading && <Loader />}
      <div className="g-grid g-header">
        <ProjectHeaderRow />
      </div>
      <div className="g-grid g-content">
        {projects &&
          projects.map((project, index) => (
            <ProjectRow
              project={project}
              employees={employeeOptions}
              key={project.projectId}
              index={index} />
          ))}
      </div>
      <div className="g-grid g-footer">
        <div className="row projects-count">
          <div className="col strong lowercase">
            Ukupno<div>{projects.length}</div>
          </div>
        </div>
      </div>
      <DeleteProjectModal />
      <Popover
        isOpen={editNotePopoverOpen.popover.isOpen}
        onClose={() => dispatch(setEditNotePopoverOpen({
          popover: { isOpen: false }
        }))}
        title="Beleška"
        direction="right"
        arrowStyle={{ top: "22px" }}
        position={{
          top: editNotePopoverOpen.popover.top,
          left: editNotePopoverOpen.popover.left,
          offsetLeft: 20,
          offsetTop: -30
        }}
      >
        <EditNotePopover
          readOnlyInput={!hasWriteAccessTo(user, PROJECT_MODULE_NAME)}
          defaultValue={editNotePopoverOpen.note}
          onNoteUpdate={async (note: string) => {
            try {
              if (editNotePopoverOpen.projectId !== undefined
                && editNotePopoverOpen.projectIndex !== undefined) {
                const project = await projectService.updateProject({
                  projectId: editNotePopoverOpen.projectId,
                  note: note
                });
                dispatch(updateProject({
                  index: editNotePopoverOpen.projectIndex,
                  project: project
                }));
              }
            } catch (error) {
              console.log(error);
            }
          }} />
      </Popover>
    </section >
  );
};

export default TopSection;
